export type languageReducerState = SupportedLanguagesEnum | null

export enum SupportedLanguagesEnum {
  EN = 'US',
  DE = 'DE',
}
